import { AxiosInstance } from 'axios';
import { createTRApi } from '@front-app/services/api';
import {
  BulkLinkRequest,
  BulkLinkResponse,
  EventSearchResponse,
  EventsSearchParams,
} from './GroupEventsModel';

const proxyPrefix = process.env.VUE_APP_EVENTS_SVC_PROXY_PREFIX;
const serviceBase = process.env.VUE_APP_EVENTS_SVC_BASE_URL;
const BASE_URL = `${(proxyPrefix || serviceBase || '')}/api/v1/group-events`;

const api: AxiosInstance = createTRApi(BASE_URL);

export const GroupEventsApi = {
  async searchEvents(params: EventsSearchParams): Promise<EventSearchResponse> {
    const { data } = await api.get('/events', { params });
    return data as EventSearchResponse;
  },

  async createLinks(body: BulkLinkRequest): Promise<BulkLinkResponse> {
    const { data } = await api.post('/links', body);
    return data as BulkLinkResponse;
  },
};
